import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Divider from "@material-ui/core/Divider";

import RefreshIcon from "@material-ui/icons/Refresh";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";

import { useStyles } from "./PageTitle.css";

class PageTitle extends Component {
  render() {
    const { classes, title, refreshUrl, addUrl, editUrl, urlTitle } =
      this.props;
    return (
      <div>
        <div className={classes.root}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <div style={{ fontSize: 30, fontWeight: "bold" }}>{title}</div>
            {refreshUrl && (
              <Tooltip
                arrow
                title="Refresh"
                className={classes.tooltip}
                onClick={() => this.props.history.push(refreshUrl)}
              >
                <RefreshIcon style={{ width: 30, height: 30 }} />
              </Tooltip>
            )}
          </div>
          {addUrl && (
            <div className={classes.content}>
              <Tooltip
                arrow
                title={urlTitle}
                className={classes.tooltip}
                onClick={() => this.props.history.push(addUrl)}
              >
                <AddCircleIcon style={{ width: 30, height: 30 }} />
              </Tooltip>
              <div style={{ fontSize: 20 }}>{urlTitle}</div>
            </div>
          )}
          {editUrl && (
            <div className={classes.content}>
              <Tooltip
                arrow
                title={urlTitle}
                className={classes.tooltip}
                onClick={() => this.props.history.push(editUrl)}
              >
                <EditIcon style={{ width: 30, height: 30 }} />
              </Tooltip>
              <div style={{ fontSize: 20 }}>{urlTitle}</div>
            </div>
          )}
        </div>
        <Divider />
        <br />
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(PageTitle));
